export default "__VITE_ASSET__4f233961__"